import React from 'react';
import { cn } from '@/utils/cn';

function HtmlParagraph({ content, className = '', ...rest }) {
  return (
    <p
      className={cn(
        'text-14 lg:text-16 text-coarse-wool font-encode-sans font-normal leading-18 lg:leading-20 tracking-[0.28px] lg:tracking-[0.32px] [&>p>a]:text-cyan-cornflower-blue [&>p>a]:font-semibold [&>p>a]:cursor-pointer',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: content }}
      {...rest}
    />
  );
}

export default HtmlParagraph;
